// preSubscribeAgoraClient.js
'use strict';
import { AGORA_RTC_APP_ID } from '../RemoteConfigKeys.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';
import getTimestampOffset, {
  Accuracy,
} from '../selector/getTimestampOffset.js';
import { joinChannelWithSubscribing } from '../resource/agora.js';
import { getAgoraInstance } from '../resource/agoraClientPool.js';

/** @kind action Pre-subscribe a prejoined Agora channel's tracks during swipe. */
const preSubscribeAgoraClient =
  ({ streamId }) =>
  async (dispatch, getState) => {
    if (!streamId) return dispatch({ type: '' });
    const state = getState();
    const sessionId = getLiveStreamData(state, [streamId], 'sessionId');
    if (!sessionId) return dispatch({ type: '' });

    const agoraInstance = getAgoraInstance({ channelId: sessionId });
    if (!agoraInstance?.joinChannelWithoutSubscribingPromise) {
      return dispatch({ type: '' });
    }

    const appId = getRemoteConfigData(state, AGORA_RTC_APP_ID);
    const token = getLiveStreamData(
      state,
      [streamId, 'providerInfo', 'agora'],
      'agoraToken'
    );
    const meSessionId = getMeData(state, 'sessionId');
    if (!appId || !token || !meSessionId) return dispatch({ type: '' });

    const agoraTokenExp = getLiveStreamData(
      state,
      [streamId, 'providerInfo', 'agora'],
      'agoraTokenExp'
    );
    const timestampOffsetMilliseconds = getTimestampOffset(
      state,
      Accuracy.MILLISECOND
    );
    const isTokenValid =
      agoraTokenExp !== -1 &&
      agoraTokenExp != null &&
      Date.now() + timestampOffsetMilliseconds < agoraTokenExp * 1000;
    if (!isTokenValid) return dispatch({ type: '' });

    return joinChannelWithSubscribing({
      appId,
      channelId: sessionId,
      token,
      sessionId: meSessionId,
      isActive: false,
    });
  };

export default preSubscribeAgoraClient;
